<template>
  <Modal
    v-model="innerShow"
    fullscreen
    footer-hide
    @on-ok="close"
    @on-cancel="close"
    class="yjh-diag yjh-diag--full">
      <slot></slot>
      <template slot="footer"></template>
    </Modal>
</template>

<script>
export default {
  props: {
    isShow: Boolean
  },
  data() {
    return {
      innerShow: false
    }
  },
  watch: {
    isShow() {
      this.innerShow = this.isShow
    }
  },
  mounted() {
    this.innerShow = this.isShow
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
// 全屏弹框
.yjh-diag--full {
  .ivu-modal-close {
    top: 60px;
    right: 60px;
    .ivu-icon-ios-close {
      width: 30px;
      height: 30px;
      background: url('../../assets/icon.svg') no-repeat -310px -23px;
      &:before {
        display: none;
      }
    }
  }
  .ivu-modal-content {
    background: rgba(0, 0, 0, 0.4);
  }
  .full-img-content {
    position: absolute;
    width: 970px;
    height: 576px;
    top: 50%;
    margin-top: -288px;
    left: 50%;
    margin-left: -485px;
    background: #fff;
    padding: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
